{
    "title": "Company Information",
    "input":{
        "countryOfIncorporation": "Country of Incorporation",
        "stateOfIncorporation": "State of Incorporation",
        "establishedOn": "Incorporation Date"
    },
    "placeholder":{
        "country": "Search for a country",
        "state": "Search for a state"
    }
}